<template>
    <div>
        <b-card tag="article" style="max-width: 100%;" class="mb-2">
            <div class="card-text">
                <b-row>
                    <b-col xs="6" md="6" lg="6">
                        <app-date-time-picker
                            :withTime="false"
                            label="Fecha de ingreso"
                            v-model="theEntry.entryDate"
                            :required="true"
                            :hasError="$v.theEntry.entryDate.$error"
                            error-message="Debe especificar la fecha"
                            :max-date="moment().toDate()"
                        />
                    </b-col>
                    <b-col xs="6" md="6" lg="6">
                        <label>
                            Hora de ingreso
                            <span class="field-required-mark">*</span>
                        </label>
                        <b-form-input
                            id="type"
                            type="time"
                            @change="$v.theEntry.checkIn.$touch()"
                            v-model="theEntry.checkIn"
                        ></b-form-input>
                        <span
                            class="field-error"
                            v-if="$v.theEntry.checkIn.$error"
                        >Debe especificar la hora</span>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <app-form-text-input
                            label="Placa"
                            id="plate"
                            :required="true"
                            :hasError="$v.theEntry.plate.$error"
                            errorMessage="Debe escribir la placa del vehículo"
                            @input="$v.theEntry.plate.$touch()"
                            v-model="theEntry.plate"
                            :input-classes="{ 'plate-input': true }"
                        ></app-form-text-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="12" lg="7">
                        <app-autocomplete
                            placeholder="Conductor"
                            :items="drivers"
                            v-model="theEntry.selectedDriver"
                        />
                    </b-col>
                    <b-col cols="12" md="5" lg="5">
                        <b-button
                            size="sm"
                            variant="outline-primary"
                            @click="newDriver"
                            v-b-toggle.collapse-3
                            class="btn-block"
                        >Nuevo conductor</b-button>
                    </b-col>
                </b-row>
                <b-collapse id="collapse-3">
                    <b-card>
                        <b-row>
                            <b-col cols="12" md="12" lg="6">
                                <app-form-text-input
                                    label="Documento conductor"
                                    id="driverDocument2"
                                    :required="true"
                                    :hasError="
                                        $v.theEntry.driverDocument.$error
                                    "
                                    errorMessage="Debe escribir el documento del conductor"
                                    @input="$v.theEntry.driverDocument.$touch()"
                                    v-model="theEntry.driverDocument"
                                ></app-form-text-input>
                            </b-col>
                            <b-col cols="12" md="12" lg="6">
                                <app-form-text-input
                                    label="Nombre conductor"
                                    id="driver"
                                    :required="true"
                                    :hasError="$v.theEntry.driverName.$error"
                                    errorMessage="Debe escribir el nombre del conductor"
                                    @input="$v.theEntry.driverName.$touch()"
                                    v-model="theEntry.driverName"
                                ></app-form-text-input>
                            </b-col>
                        </b-row>
                    </b-card>
                    <br />
                </b-collapse>
                <b-row>
                    <b-col cols="12" md="12" lg="7">
                        <app-autocomplete
                            placeholder="Proveedor"
                            :items="vendors"
                            v-model="theEntry.selectedVendor"
                        />
                    </b-col>
                    <b-col cols="12" md="5" lg="5">
                        <b-button
                            size="sm"
                            variant="outline-primary"
                            @click="newVendor"
                            v-b-toggle.collapse-2
                            class="btn-block"
                        >Nuevo proveedor</b-button>
                    </b-col>
                </b-row>
                <b-collapse id="collapse-2">
                    <b-card>
                        <b-row>
                            <b-col cols="12" md="12" lg="6">
                                <app-form-text-input
                                    label="NIT Proveedor"
                                    id="vendorNit"
                                    :required="true"
                                    :hasError="$v.theEntry.vendorNit.$error"
                                    errorMessage="Debe escribir el NIT del proveedor"
                                    @input="$v.theEntry.vendorNit.$touch()"
                                    v-model="theEntry.vendorNit"
                                ></app-form-text-input>
                            </b-col>
                            <b-col cols="12" md="12" lg="6">
                                <app-form-text-input
                                    label="Nombre Proveedor"
                                    id="vendorName"
                                    :required="true"
                                    :hasError="$v.theEntry.vendorName.$error"
                                    errorMessage="Debe escribir el nombre del proveedor"
                                    @input="$v.theEntry.vendorName.$touch()"
                                    v-model="theEntry.vendorName"
                                ></app-form-text-input>
                            </b-col>
                        </b-row>
                    </b-card>
                    <br />
                </b-collapse>
                <b-row>
                    <b-col cols="12" md="12" lg="6">
                        <app-form-text-input
                            label="Material"
                            id="material"
                            v-model="theEntry.material"
                            :required="true"
                            :hasError="$v.theEntry.material.$error"
                            errorMessage="debe escribir que tipo de material carga"
                            @input="$v.theEntry.material.$touch()"
                        >></app-form-text-input>
                    </b-col>
                    <b-col cols="12" md="12" lg="6">
                        <app-form-text-input
                            label="Peso de entrada (Toneladas)"
                            id="initialWeight"
                            :required="true"
                            v-model="theEntry.initialWeight"
                            :hasError="$v.theEntry.initialWeight.$error"
                            errorMessage="debe escribir un número valido"
                            @input="$v.theEntry.initialWeight.$touch()"
                        ></app-form-text-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" :lg="!!checked ? 6 : 12">
                        <b-form-checkbox
                            v-model="checked"
                            name="check-button"
                            switch
                        >¿Tiene auxiliar?</b-form-checkbox>
                    </b-col>
                    <b-col cols="12" md="7" lg="7">
                        <br />
                        <app-form-text-input
                            v-if="checked"
                            label="Nombre auxiliar"
                            id="auxiliar"
                            v-model="theEntry.deliveredBy"
                        ></app-form-text-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="12" lg="12">
                        <br />
                        <app-form-textarea-input
                            label="Notas de entrada"
                            id="entryNotes"
                            v-model="theEntry.entryNotes"
                        />
                    </b-col>
                </b-row>
                <div v-if="!myEntry">
                    <b-row>
                        <b-col cols="12" md="6" lg="6">
                            <b-btn v-b-toggle.collapse1 variant="primary" class="btn-block">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                Agregar fotos
                            </b-btn>
                        </b-col>
                    </b-row>
                    <b-collapse id="collapse1" class="mt-2">
                        <b-row>
                            <b-col cols="12" md="12" lg="12">
                                <b-card>
                                    <div class="card-text">
                                        <app-upload-or-take-photo
                                            id="cargo-vehicle-entry-photos"
                                            title="Fotos de vehículo de carga"
                                            v-model="files"
                                        />
                                        <div
                                            v-if="
                                                files.files &&
                                                    files.files.length
                                            "
                                        >
                                            <button
                                                class="btn btn-sm btn-danger pull-right"
                                                @click="cancelFilesSelected"
                                            >
                                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                                Cancelar archivos seleccionados
                                            </button>
                                        </div>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-collapse>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from '../../../../../../components/UI/Controls/AutocompleteV2/Autocomplete.vue'
import { required } from 'vuelidate/lib/validators'
import { decimal } from '../../../../../../utils/CustomValidators'
import UploadOrTakePhoto from '../../../../../UI/Controls/Photos/UploadOrTakePhoto.vue'
import cargoVehicleEntriesRepository from '../../../../../../repositories/cargoVehicleEntries.repository'
import { mapGetters } from 'vuex'
export default {
    components: {
        appAutocomplete: Autocomplete,
        appUploadOrTakePhoto: UploadOrTakePhoto,
    },

    props: {
        onSave: {
            type: Function,
        },
        myEntry: {
            default: null,
        },
    },

    data() {
        return {
            theEntry: {
                entryNotes: '',
                deliveredBy: '',
                material: '',
                initialWeight: '',
                plate: '',
                entryDate: '',
                checkIn: '',
                vendorName: '',
                vendorNit: '',
                driverDocument: '',
                driverName: '',
                selectedDriver: '',
                selectedVendor: '',
            },
            checked: false,
            files: '',
            vendors: [],
            drivers: [],
            isNewDriver: false,
            isNewVendor: false,
        }
    },
    validations: {
        theEntry: {
            driverName: { required },
            driverDocument: { required },
            vendorNit: { required },
            vendorName: { required },
            entryDate: { required },
            checkIn: { required },
            plate: { required },
            initialWeight: { decimal, required },
            material: { required },
        },
    },

    watch: {
        myEntry(val) {
            this.fillForm()
        },
        'theEntry.selectedDriver'(val) {
            if (val) {
                this.theEntry.driverName = val.name
                this.theEntry.driverDocument = val.document
                this.isNewDriver = false
            } else {
                this.isNewDriver = true
            }
        },
        'theEntry.selectedVendor'(val) {
            if (val) {
                this.theEntry.vendorName = val.name
                this.theEntry.vendorNit = val.document
                this.isNewVendor = false
            } else {
                this.isNewVendor = true
            }
        },
        ['theEntry.plate'](val) {
            const rx = /[^A-Z0-9]/gi
            this.$set(this.theEntry, 'plate', val.replace(rx, ''))
        },
    },
    computed: {
        ...mapGetters(['clients']),
    },
    methods: {
        newDriver() {
            this.isNewDriver = true
            this.theEntry.selectedDriver = ''
            this.theEntry.driverDocument = ''
            this.theEntry.driverName = ''
        },
        newVendor() {
            this.isNewVendor = true
            this.theEntry.selectedVendor = ''
            this.theEntry.vendorName = ''
            this.theEntry.vendorNit = ''
        },
        saveEntry() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const formData = new FormData()

            formData.append('clientId', this.client.id)
            formData.append('structureId', this.accessPoint.id)
            formData.append('venueId', this.accessPoint.venue_id)
            formData.append('entryRegisteredById', this.user.id)
            formData.append('entryNotes', this.theEntry.entryNotes)
            formData.append(
                'deliveredBy',
                !!this.checked
                    ? this.theEntry.deliveredBy
                    : this.theEntry.driverName
            )
            formData.append('material', this.theEntry.material)
            formData.append('initialWeight', this.theEntry.initialWeight)
            formData.append('plate', this.theEntry.plate)
            formData.append('entryDate', this.theEntry.entryDate)
            formData.append('checkIn', this.theEntry.checkIn)
            formData.append('isNewDriver', !!this.isNewDriver ? 1 : 0)
            formData.append('isNewVendor', !!this.isNewVendor ? 1 : 0)
            if (!this.isNewDriver) {
                formData.append('driverId', this.theEntry.selectedDriver.id)
            } else {
                formData.append('driverDocument', this.theEntry.driverDocument)
                formData.append('driverName', this.theEntry.driverName)
            }
            if (!this.isNewVendor) {
                formData.append('vendorId', this.theEntry.selectedVendor.id)
            } else {
                formData.append('vendorNit', this.theEntry.vendorNit)
                formData.append('vendorName', this.theEntry.vendorName)
            }

            if (this.files.photos) {
                this.files.photos.map(item => formData.append('photos[]', item))
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append('file' + index, item)
                )
            }

            const cver = { ...cargoVehicleEntriesRepository }
            cver.saveCargoVehicleEntry(formData)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.cleanForm()
                        this.loadCargoDrivers()
                        this.loadCargoVendors()
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al guardar el ingreso de vehículo de carga'
                    )
                })
        },
        updateEntry(id) {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const cver = { ...cargoVehicleEntriesRepository }
            cver.updateCargoVehicleEntry(this.theEntry, this.myEntry.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.cleanForm()
                        this.loadCargoDrivers()
                        this.loadCargoVendors()
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al actualizar el ingreso de vehículo de carga'
                    )
                })
        },
        saveOrUpdate() {
            if (!!this.myEntry) {
                this.updateEntry()
            } else {
                this.saveEntry()
            }
        },
        fillForm() {
            if (!!this.myEntry && Object.keys(this.myEntry).length !== 0) {
                this.theEntry.entryNotes = this.myEntry.entry_notes
                this.theEntry.material = this.myEntry.material
                this.theEntry.initialWeight = this.myEntry.initial_weight
                this.theEntry.plate = this.myEntry.plate
                this.theEntry.vendorName = this.myEntry.cargo_vendor.name
                this.theEntry.vendorNit = this.myEntry.cargo_vendor.document
                this.theEntry.driverName = this.myEntry.entry_cargo_driver.name
                this.theEntry.driverDocument = this.myEntry.entry_cargo_driver.document
                this.theEntry.entryDate = this.myEntry.entry_date
                this.theEntry.deliveredBy = this.myEntry.delivered_by
            } else {
                this.cleanForm()
            }
        },
        loadCargoVendors() {
            const cver = { ...cargoVehicleEntriesRepository }
            cver.loadCargoVehicleVendors({ client: this.client.id })
                .then(({ data }) => (this.vendors = data))
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar los proveedores')
                )
        },
        loadCargoDrivers() {
            const cver = { ...cargoVehicleEntriesRepository }
            cver.loadCargoVehicleDrivers({ client: this.client.id })
                .then(({ data }) => (this.drivers = data))
                .catch(error =>
                    toastr.error('Ocurrió un error al cargar los conductores')
                )
        },
        cleanForm() {
            Object.keys(this.theEntry).map(key => (this.theEntry[key] = ''))
            this.setAutoDateTime()
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.$bus.$emit('cargo-vehicle-entry-photos.clean')
        },
        cancelFilesSelected() {
            this.$bus.$emit('cargo-vehicle-entry-photos.clean')
            this.files = ''
            toastr.success('Archivos cancelados')
        },
        initialize() {
            this.load('clients')
            this.loadCargoDrivers()
            this.loadCargoVendors()
        },
        setAutoDateTime() {
            this.theEntry.entryDate = moment().format('YYYY-MM-DD')
            this.theEntry.checkIn = moment().format('HH:mm')
        },
    },
    created() {
        this.initialize()
        this.$bus.$on('cargo-vehicle-entry-form.save', this.saveOrUpdate)
        this.$bus.$on('cargo-vehicle-entry-form.clean', this.cleanForm)
    },
    mounted() {
        this.setAutoDateTime()
    },
    beforeDestroy() {
        this.$bus.$off('cargo-vehicle-entry-form.save')
    },
}
</script>
